import { render, staticRenderFns } from "./AsideLeft.vue?vue&type=template&id=8b53481a"
import script from "./AsideLeft.vue?vue&type=script&lang=js"
export * from "./AsideLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports